mutation DeleteForm($id: ID!) {
    formDelete(input: {id: $id}) {
        form {
            id
        }
    }
}
